var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height notranslate",attrs:{"id":"mainWrapper","translate":"no"}},[(_vm.showLoading)?_c('Loading'):_c(_vm.layout,{tag:"component"},[_c('custom-snackbar'),_c('router-view',{key:_vm.$route.fullPath}),(!_vm.isNotFound)?_c('ShowNotifications'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }